module.exports = __webpack_public_path__ + "img/tax-empty-image.482eda94.webp";